import { socialPostsConstants } from '@constants/social-posts';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { socialPostsService } from '@services';

let requestCounter = 0;
const nextRequestId = () => (requestCounter += 1);

function request(requestId) {
    return { type: socialPostsConstants.SOCIAL_POSTS_FETCH, requestId };
}

function success(data, requestId) {
    return { type: socialPostsConstants.SOCIAL_POSTS_SUCCESS, data, requestId };
}

function failure(message, requestId) {
    return { type: socialPostsConstants.SOCIAL_POSTS_ERROR, message, requestId };
}

const get = (page = 0, pageSize = DEFAULT_PAGE_SIZE, filter = {}) => {
    return dispatch => {
        const requestId = nextRequestId();
        dispatch(request(requestId));
        socialPostsService.get(page, pageSize, filter).then(
            data => dispatch(success(data, requestId)),
            () => dispatch(failure(undefined, requestId)),
        );
    };
};

const setSocialPosts = data => {
    return { type: socialPostsConstants.SET_SOCIAL_POSTS, data };
};

const updatePost = post => {
    return { type: socialPostsConstants.SOCIAL_POSTS_UPDATE_POST, post };
};

const reset = () => {
    return { type: socialPostsConstants.RESET_SOCIAL_POSTS, requestId: nextRequestId() };
};

export const socialPostsActions = {
    get,
    setSocialPosts,
    updatePost,
    reset,
};
